import { useNavigate } from 'react-router-dom'
import styles from './Hero.module.css'

export function Hero() {
  const navigate = useNavigate()

  const handleGetStarted = () => {
    navigate('/', { state: { direct: true } })
  }

  const handleViewCarts = () => {
    navigate('/', { state: { view: 'library' } })
  }

  const handleViewDocs = () => {
    navigate('/docs')
  }

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <h1 className={styles.title}>Fantasy Console 0</h1>
        <p className={styles.subtitle}>A JavaScript-based fantasy console</p>
        <p className={styles.description}>
          Play, create, and share pixel art games right from your browser. No
          installation required.
        </p>
        <div className={styles.ctas}>
          <button className='btn btn-primary' onClick={handleGetStarted}>
            Get Started
          </button>
          <button className='btn btn-secondary' onClick={handleViewCarts}>
            View Carts
          </button>
          <button className='btn btn-secondary' onClick={handleViewDocs}>
            View Docs
          </button>
        </div>
      </div>
      <div className={styles.preview}>
        <img
          className={styles.previewImage}
          src='/fc0_editor_img.png'
          alt='Fantasy Console 0 editor'
        />
      </div>
    </section>
  )
}
